import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const formsApi = createApi({
  reducerPath: 'formsApi',
  baseQuery: createBaseQuery('forms', { timeout: 0 }),
  endpoints: builder => ({
    getFormFromFile: builder.mutation({
      query: data => ({
        url: '/from_file',
        method: 'POST',
        body: data,
      }),
      transformResponse: ({ result }) => result,
    }),
    getForm: builder.query({
      query: id => `/${id}`,
      transformResponse: ({ result }) => result,
    }),
    getForms: builder.query({
      query: () => '/',
      transformResponse: ({ result }) => result,
    }),
    getFormsByType: builder.query({
      query: type => `/type/${type}`,
      transformResponse: ({ result }) => result,
    }),
    getFormsById: builder.query({
      query: ids => `/ids/${ids.join(',')}`,
      transformResponse: ({ result }) => result,
    }),
    getFormAnswersForCandidate: builder.query({
      query: ({ id, candidateId }) => `/${id}/candidate/${candidateId}/answers`,
      transformResponse: ({ result }) => result,
    }),
    getFormByTypeformId: builder.query({
      query: typeformId => `/typeform/${typeformId}`,
      transformResponse: ({ result }) => result,
    }),
    getTypeformAnswersForCandidate: builder.query({
      query: candidateId => `/candidate/${candidateId}/typeform/answers`,
      transformResponse: ({ result }) => result,
    }),
    getTypeformAnswersByToken: builder.query({
      query: token => `/token/${token}/typeform/answers`,
      transformResponse: ({ result }) => result,
    }),
    getFormByTypeformIdByToken: builder.query({
      query: ({ token, typeformId }) => `/token/${token}/typeform/${typeformId}`,
      transformResponse: ({ result }) => result,
    }),
    getUiTranslations: builder.query({
      query: language_code => `/ui_translations?language_code=${language_code}`,
      transformResponse: ({ result }) => result,
    }),
    getFormFieldTranslations: builder.mutation({
      query: ({ id, language_code }) => ({
        url: `/${id}/field_translations`,
        method: 'POST',
        body: { language_code },
      }),
      transformResponse: ({ result }) => result,
    }),
    createFormFieldTranslations: builder.mutation({
      query: ({ id, language_code }) => ({
        url: `/${id}/field_translations_public`,
        method: 'POST',
        body: { language_code },
      }),
      transformResponse: ({ result }) => result,
    }),
    getUiTranslationsPublic: builder.query({
      query: language_code => `/ui_translations_public?language_code=${language_code}`,
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const {
  useLazyGetFormByTypeformIdByTokenQuery,
  useLazyGetUiTranslationsQuery,
  useGetFormFieldTranslationsMutation,
  useCreateFormFieldTranslationsMutation,
  useLazyGetUiTranslationsPublicQuery,
  useLazyGetTypeformAnswersByTokenQuery,
  useLazyGetFormsByIdQuery,
  useGetFormsByTypeQuery,
  useGetTypeformAnswersForCandidateQuery,
  useGetFormByTypeformIdQuery,
  useGetFormQuery,
  useLazyGetFormAnswersForCandidateQuery,
  useGetFormFromFileMutation,
} = formsApi;
